const esculturasPath = 'assets/img/portfolio/esculturas/';
const pinturaPath = 'assets/img/portfolio/pintura/';
const cenografiaPath = 'assets/img/portfolio/cenografia/';
const acrilicosPath = 'assets/img/portfolio/acrilicos/';
const cortePath = 'assets/img/portfolio/corte/';
const impressaoPath = 'assets/img/portfolio/impressao/';
const barroPath = 'assets/img/portfolio/esculturas/barro/';
const esferovitePath = 'assets/img/portfolio/esculturas/esferovite/';
const fibraPath = 'assets/img/portfolio/esculturas/fibra/';
const gessoPath = 'assets/img/portfolio/esculturas/gesso/';
const madeiraPath = 'assets/img/portfolio/esculturas/madeira/';
const moldesPath = 'assets/img/portfolio/moldes/';
const ultimosTrabalhosPath = 'assets/img/portfolio/ultimos/';

export const IMAGES = {
  esculturas: [
    
    
    {
      src: `${esculturasPath}1.jpg`,
      srcGrid: `${esculturasPath}grid/1.jpg`,
      caption: 'Burro em fibra de vidro'
    },
    {
      src: `${esculturasPath}2.jpg`,
      srcGrid: `${esculturasPath}grid/2.jpg`,
      caption: 'Busto em barro'
    },
    {
      src: `${esculturasPath}3.jpg`,
      srcGrid: `${esculturasPath}grid/3.jpg`,
      caption: 'Busto em barro'
    },
    {
      src: `${esculturasPath}4.jpg`,
      srcGrid: `${esculturasPath}grid/4.jpg`,
      caption: 'Escultura cabeça de gato e pintura para programa'
    },
    {
      src: `${esculturasPath}5.jpg`,
      srcGrid: `${esculturasPath}grid/5.jpg`,
      caption: 'Escultura de cabeça de vaca em esferovite para publicidade'
    },
    {
      src: `${esculturasPath}6.jpg`,
      srcGrid: `${esculturasPath}grid/6.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${esculturasPath}7.jpg`,
      srcGrid: `${esculturasPath}grid/7.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${esculturasPath}8.jpg`,
      srcGrid: `${esculturasPath}grid/8.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${esculturasPath}9.jpg`,
      srcGrid: `${esculturasPath}grid/9.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esculturasPath}10.jpg`,
      srcGrid: `${esculturasPath}grid/10.jpg`,
      caption: 'Escultura em esferovite de jogador para publicidade'
    },
    {
      src: `${esculturasPath}11.jpg`,
      srcGrid: `${esculturasPath}grid/11.jpg`,
      caption: 'Escultura em esferovite e cimento para série'
    },
    {
      src: `${esculturasPath}12.jpg`,
      srcGrid: `${esculturasPath}grid/12.jpg`,
      caption: 'Escultura em esferovite e cimento para serie'
    },
    {
      src: `${esculturasPath}13.jpg`,
      srcGrid: `${esculturasPath}grid/13.jpg`,
      caption: 'Escultura em esferovite e massa para novela'
    },
    {
      src: `${esculturasPath}14.jpg`,
      srcGrid: `${esculturasPath}grid/14.jpg`,
      caption: 'Escultura em esferovite e massa, Rei D. Dinis'
    },
    {
      src: `${esculturasPath}15.jpg`,
      srcGrid: `${esculturasPath}grid/15.jpg`,
      caption: 'Escultura em esferovite e resina no Palácio de Oeiras'
    },
    {
      src: `${esculturasPath}16.jpg`,
      srcGrid: `${esculturasPath}grid/16.jpg`,
      caption: 'Escultura em esferovite para série'
    },
    {
      src: `${esculturasPath}17.jpg`,
      srcGrid: `${esculturasPath}grid/17.jpg`,
      caption: 'Escultura em esferovite para série'
    },
    {
      src: `${esculturasPath}18.jpg`,
      srcGrid: `${esculturasPath}grid/18.jpg`,
      caption: 'Escultura em fibra e resina acrílica exposição temática museu em Timor'
    },
    {
      src: `${esculturasPath}19.jpg`,
      srcGrid: `${esculturasPath}grid/19.jpg`,
      caption: 'Escultura em fibra e resina acrílica museu em Timor'
    },
    {
      src: `${esculturasPath}20.jpg`,
      srcGrid: `${esculturasPath}grid/20.jpg`,
      caption: 'Escultura em fibra e resina acrílica museu em Timor'
    },
    {
      src: `${esculturasPath}21.jpg`,
      srcGrid: `${esculturasPath}grid/21.jpg`,
      caption: 'Escultura em gesso'
    },
    {
      src: `${esculturasPath}22.jpg`,
      srcGrid: `${esculturasPath}grid/22.jpg`,
      caption: 'Escultura em madeira de pinho'
    },
    {
      src: `${esculturasPath}23.jpg`,
      srcGrid: `${esculturasPath}grid/23.jpg`,
      caption: 'Escultura esferovite Hércules'
    },
    {
      src: `${esculturasPath}24.jpg`,
      srcGrid: `${esculturasPath}grid/24.jpg`,
      caption: 'Escultura madeira'
    },
    {
      src: `${esculturasPath}25.jpg`,
      srcGrid: `${esculturasPath}grid/25.jpg`,
      caption: 'Escultura peça presépio'
    },
    {
      src: `${esculturasPath}26.jpg`,
      srcGrid: `${esculturasPath}grid/26.jpg`,
      caption: 'Esculturas em esferovite exposição temática museu Aljube'
    },
    {
      src: `${esculturasPath}27.jpg`,
      srcGrid: `${esculturasPath}grid/27.jpg`,
      caption: 'Escultura em gesso'
    },
    {
      src: `${esculturasPath}28.jpg`,
      srcGrid: `${esculturasPath}grid/28.jpg`,
      caption: 'Esculturas em fibra epóxi em ISEG'
    },
    {
      src: `${esculturasPath}29.jpg`,
      srcGrid: `${esculturasPath}grid/29.jpg`,
      caption: 'Esculturas para carros alegóricos de carnaval'
    },
    {
      src: `${esculturasPath}30.jpg`,
      srcGrid: `${esculturasPath}grid/30.jpg`,
      caption: 'Estudo em barro auto retrato'
    },
    {
      src: `${esculturasPath}31.jpg`,
      srcGrid: `${esculturasPath}grid/31.jpg`,
      caption: 'Estudo escultura em ripas madeira pinho'
    },
    {
      src: `${esculturasPath}32.jpg`,
      srcGrid: `${esculturasPath}grid/32.jpg`,
      caption: 'Estudo modelação em barro para samurai'
    },
    {
      src: `${esculturasPath}33.jpg`,
      srcGrid: `${esculturasPath}grid/33.jpg`,
      caption: 'Modelação cabeça Papa Francisco em escala pequena'
    },
    {
      src: `${esculturasPath}34.jpg`,
      srcGrid: `${esculturasPath}grid/34.jpg`,
      caption: 'Pormenor compsição em barro das esculturas para a Igreja dos pastorinhos'
    },
    {
      src: `${esculturasPath}35.jpg`,
      srcGrid: `${esculturasPath}grid/35.jpg`,
      caption: 'Pormenor da composição escultórica na Igreja dos Pastorinhos'
    },
    {
      src: `${esculturasPath}36.jpg`,
      srcGrid: `${esculturasPath}grid/36.jpg`,
      caption: 'Pormenor modelação em barro para a composição escultórica na Igreja dos Pastorinhos'
    },
    {
      src: `${esculturasPath}37.jpg`,
      srcGrid: `${esculturasPath}grid/37.jpg`,
      caption: 'Presépio Natal em fibra resina e tecido serapilheira'
    }
    
  ],
  pinturas: [
    {
      src: `${pinturaPath}1.jpg`,
      srcGrid: `${pinturaPath}/grid/1.jpg`,
      caption: 'Arco das marchas de Lisboa'
    },
    {
      src: `${pinturaPath}2.jpg`,
      srcGrid: `${pinturaPath}/grid/2.jpg`,
      caption: 'Arco das marchas de Lisboa'
    },
    {
      src: `${pinturaPath}3.jpg`,
      srcGrid: `${pinturaPath}/grid/3.jpg`,
      caption: 'Pintura decoração Egípcia'
    },
    {
      src: `${pinturaPath}4.jpg`,
      srcGrid: `${pinturaPath}/grid/4.jpg`,
      caption: 'Patine decor'
    },
    {
      src: `${pinturaPath}5.jpg`,
      srcGrid: `${pinturaPath}/grid/5.jpg`,
      caption: 'Imitação mármore rosa'
    },
    {
      src: `${pinturaPath}6.jpg`,
      srcGrid: `${pinturaPath}/grid/6.jpg`,
      caption: 'Pintura de tela para teatro'
    },
    {
      src: `${pinturaPath}7.jpg`,
      srcGrid: `${pinturaPath}/grid/7.jpg`,
      caption: 'Patine decor'
    },
    {
      src: `${pinturaPath}8.jpg`,
      srcGrid: `${pinturaPath}/grid/8.jpg`,
      caption: 'Imitação mármore rosa'
    },
    {
      src: `${pinturaPath}9.jpg`,
      srcGrid: `${pinturaPath}/grid/9.jpg`,
      caption: 'Patine decor'
    },
    {
      src: `${pinturaPath}10.jpg`,
      srcGrid: `${pinturaPath}/grid/10.jpg`,
      caption: 'Imitação mármore rosa'
    },
    {
      src: `${pinturaPath}11.jpg`,
      srcGrid: `${pinturaPath}/grid/11.jpg`,
      caption: 'Imitação mármore cenário'
    },
    {
      src: `${pinturaPath}12.jpg`,
      srcGrid: `${pinturaPath}/grid/12.jpg`,
      caption: 'Pintura chão em mosaico tipo mármore'
    },
    {
      src: `${pinturaPath}13.jpg`,
      srcGrid: `${pinturaPath}/grid/13.jpg`,
      caption: 'Patine de portão para filme'
    },
    {
      src: `${pinturaPath}14.jpg`,
      srcGrid: `${pinturaPath}/grid/14.jpg`,
      caption: 'Patine decor'
    },
    {
      src: `${pinturaPath}15.jpg`,
      srcGrid: `${pinturaPath}/grid/15.jpg`,
      caption: 'Imitação de mármore'
    }
  ],
  acrilicos: [
    {
      src: `${acrilicosPath}1.jpg`,
      srcGrid: `${acrilicosPath}/grid/1.jpg`,
      caption: 'Caixas e dispensadore em acrílico cristal'
    },
    {
      src: `${acrilicosPath}2.jpg`,
      srcGrid: `${acrilicosPath}/grid/2.jpg`,
      caption: 'Corte e quinagem de acrílico'
    },
    {
      src: `${acrilicosPath}3.jpg`,
      srcGrid: `${acrilicosPath}/grid/3.jpg`,
      caption: 'Letras em acrílico'
    },
    {
      src: `${acrilicosPath}4.jpg`,
      srcGrid: `${acrilicosPath}/grid/4.jpg`,
      caption: 'Pintura 1'
    },
    {
      src: `${acrilicosPath}5.jpg`,
      srcGrid: `${acrilicosPath}/grid/5.jpg`,
      caption: 'Pintura 1'
    },
    {
      src: `${acrilicosPath}6.jpg`,
      srcGrid: `${acrilicosPath}/grid/6.jpg`,
      caption: 'Pintura 1'
    }
  ],
  impressao: [
    {
      src: `${impressaoPath}1.jpg`,
      srcGrid: `${impressaoPath}/grid/1.jpg`,
      caption: 'Impressão digital de lonas e aplicação para cenário'
    },
    {
      src: `${impressaoPath}2.jpg`,
      srcGrid: `${impressaoPath}/grid/2.jpg`,
      caption: 'Aplicação de imagem digital em parede'
    },
    {
      src: `${impressaoPath}3.jpg`,
      srcGrid: `${impressaoPath}/grid/3.jpg`,
      caption: 'Aplicação de papel de parede para publicidade'
    },
    {
      src: `${impressaoPath}4.jpg`,
      srcGrid: `${impressaoPath}/grid/4.jpg`,
      caption: 'Aplicação de papel de parede para publicidade'
    },
    {
      src: `${impressaoPath}5.jpg`,
      srcGrid: `${impressaoPath}/grid/5.jpg`,
      caption: 'Aplicação de papel de parede para publicidade'
    },
    {
      src: `${impressaoPath}6.jpg`,
      srcGrid: `${impressaoPath}/grid/6.jpg`,
      caption: 'Aplicação de papel de parede para publicidade'
    },
    {
      src: `${impressaoPath}7.jpg`,
      srcGrid: `${impressaoPath}/grid/7.jpg`,
      caption: 'Aplicação de vinil em autocarro para publicidade'
    },
    {
      src: `${impressaoPath}8.jpg`,
      srcGrid: `${impressaoPath}/grid/8.jpg`,
      caption: 'Aplicação de vinil em viatura para publicidade'
    },
    {
      src: `${impressaoPath}9.jpg`,
      srcGrid: `${impressaoPath}/grid/9.jpg`,
      caption: 'Aplicação de vinil impresso em cenário'
    },
    {
      src: `${impressaoPath}10.jpg`,
      srcGrid: `${impressaoPath}/grid/10.jpg`,
      caption: 'Aplicação de vinil para publicidade'
    },
    {
      src: `${impressaoPath}11.jpg`,
      srcGrid: `${impressaoPath}/grid/11.jpg`,
      caption: 'Aplicação de vinil'
    },
    {
      src: `${impressaoPath}12.jpg`,
      srcGrid: `${impressaoPath}/grid/12.jpg`,
      caption: 'Impressão digital e aplicação de vinil para programa'
    },
    {
      src: `${impressaoPath}13.jpg`,
      srcGrid: `${impressaoPath}/grid/13.jpg`,
      caption: 'Impressão digital e aplicação de vinil para publicidade'
    },
    {
      src: `${impressaoPath}14.jpg`,
      srcGrid: `${impressaoPath}/grid/14.jpg`,
      caption: 'Impressão digital e aplicação de vinil'
    },
    {
      src: `${impressaoPath}15.jpg`,
      srcGrid: `${impressaoPath}/grid/15.jpg`,
      caption: 'Impressão digital e aplicação em cenário'
    },
    {
      src: `${impressaoPath}16.jpg`,
      srcGrid: `${impressaoPath}/grid/16.jpg`,
      caption: 'Impressão digital, aplicação e patine'
    },
    {
      src: `${impressaoPath}17.jpg`,
      srcGrid: `${impressaoPath}/grid/17.jpg`,
      caption: 'Impressão digital'
    },
    {
      src: `${impressaoPath}18.jpg`,
      srcGrid: `${impressaoPath}/grid/18.jpg`,
      caption: 'Impressão e aplicação de vinil para publicidade'
    },
    {
      src: `${impressaoPath}19.jpg`,
      srcGrid: `${impressaoPath}/grid/19.jpg`,
      caption: 'Vinil aplicado em viatura para publicidade'
    }
  ],
  cenografia: [
    {
      src: `${cenografiaPath}1.jpg`,
      srcGrid: `${cenografiaPath}grid/1.jpg`,
      caption: 'Imitação casca de árvore para publicidade'
    },
    {
      src: `${cenografiaPath}2.jpg`,
      srcGrid: `${cenografiaPath}grid/2.jpg`,
      caption: 'Adereço de cenografia'
    },
    {
      src: `${cenografiaPath}3.jpg`,
      srcGrid: `${cenografiaPath}grid/3.jpg`,
      caption: 'Imitação parede tijolo burro em esferovite'
    },
    {
      src: `${cenografiaPath}4.jpg`,
      srcGrid: `${cenografiaPath}grid/4.jpg`,
      caption: 'Adereço em esferovite com patine para novela'
    },
    {
      src: `${cenografiaPath}5.jpg`,
      srcGrid: `${cenografiaPath}grid/5.jpg`,
      caption: 'Adereço em esferovite museu SLB'
    },
    {
      src: `${cenografiaPath}6.jpg`,
      srcGrid: `${cenografiaPath}grid/6.jpg`,
      caption: 'Adereço em esferovite museu SLB'
    },
    {
      src: `${cenografiaPath}7.jpg`,
      srcGrid: `${cenografiaPath}grid/7.jpg`,
      caption: 'Adereço em esferovite museu SLB'
    },
    {
      src: `${cenografiaPath}8.jpg`,
      srcGrid: `${cenografiaPath}grid/8.jpg`,
      caption: 'Adereço em esferovite para enfeite janela'
    },
    {
      src: `${cenografiaPath}9.jpg`,
      srcGrid: `${cenografiaPath}grid/9.jpg`,
      caption: 'Adereço em esferovite para filme'
    },
    {
      src: `${cenografiaPath}10.jpg`,
      srcGrid: `${cenografiaPath}grid/10.jpg`,
      caption: 'Adereço em esferovite para programa'
    },
    {
      src: `${cenografiaPath}11.jpg`,
      srcGrid: `${cenografiaPath}grid/11.jpg`,
      caption: 'Adereço em esferovite para publicidade'
    },
    {
      src: `${cenografiaPath}12.jpg`,
      srcGrid: `${cenografiaPath}grid/12.jpg`,
      caption: 'Adereço em esferovite pintado e patinado'
    },
    {
      src: `${cenografiaPath}13.jpg`,
      srcGrid: `${cenografiaPath}grid/13.jpg`,
      caption: 'Adereço em gesso para cenário'
    },
    {
      src: `${cenografiaPath}14.jpg`,
      srcGrid: `${cenografiaPath}grid/14.jpg`,
      caption: 'Adereço falso para efeitos especiais'
    },
    {
      src: `${cenografiaPath}15.jpg`,
      srcGrid: `${cenografiaPath}grid/15.jpg`,
      caption: 'Adereço para série'
    },
    {
      src: `${cenografiaPath}16.jpg`,
      srcGrid: `${cenografiaPath}grid/16.jpg`,
      caption: 'Bacalhau em latex para efeito especial'
    },
    {
      src: `${cenografiaPath}17.jpg`,
      srcGrid: `${cenografiaPath}grid/17.jpg`,
      caption: 'Bacalhau em latex para efeito especial'
    },
    {
      src: `${cenografiaPath}18.jpg`,
      srcGrid: `${cenografiaPath}grid/18.jpg`,
      caption: 'Adereços em esferovite para exposição temática'
    },
    {
      src: `${cenografiaPath}19.jpg`,
      srcGrid: `${cenografiaPath}grid/19.jpg`,
      caption: 'Adereços em esferovite para marchas de Lisboa'
    },
    {
      src: `${cenografiaPath}20.jpg`,
      srcGrid: `${cenografiaPath}grid/20.jpg`,
      caption: 'Adereços em esferovite para marchas de Lisboa'
    },
    {
      src: `${cenografiaPath}21.jpg`,
      srcGrid: `${cenografiaPath}grid/21.jpg`,
      caption: 'Adereços em esferovite para marchas de Lisboa'
    },
    {
      src: `${cenografiaPath}22.jpg`,
      srcGrid: `${cenografiaPath}grid/22.jpg`,
      caption: 'Adereços em esferovite para publicidade'
    },
    {
      src: `${cenografiaPath}23.jpg`,
      srcGrid: `${cenografiaPath}grid/23.jpg`,
      caption: 'Adereços em latex'
    },
    {
      src: `${cenografiaPath}24.jpg`,
      srcGrid: `${cenografiaPath}grid/24.jpg`,
      caption: 'Adereços em latex'
    },
    {
      src: `${cenografiaPath}25.jpg`,
      srcGrid: `${cenografiaPath}grid/25.jpg`,
      caption: 'Adereços em latex'
    },
    {
      src: `${cenografiaPath}26.jpg`,
      srcGrid: `${cenografiaPath}grid/26.jpg`,
      caption: 'Adereços em latex'
    },
    {
      src: `${cenografiaPath}27.jpg`,
      srcGrid: `${cenografiaPath}grid/27.jpg`,
      caption: 'Adereços em latex'
    },
    {
      src: `${cenografiaPath}28.jpg`,
      srcGrid: `${cenografiaPath}grid/28.jpg`,
      caption: 'Barro seco para efeito especial'
    },
    {
      src: `${cenografiaPath}29.jpg`,
      srcGrid: `${cenografiaPath}grid/29.jpg`,
      caption: 'Baú esferovite compatine'
    },
    {
      src: `${cenografiaPath}30.jpg`,
      srcGrid: `${cenografiaPath}grid/30.jpg`,
      caption: 'Baú esferovite'
    },
    {
      src: `${cenografiaPath}31.jpg`,
      srcGrid: `${cenografiaPath}grid/31.jpg`,
      caption: 'Cabeça de T-Rex para programa em esferovite'
    },
    {
      src: `${cenografiaPath}32.jpg`,
      srcGrid: `${cenografiaPath}grid/32.jpg`,
      caption: 'Cabeças de lobo em latex e pintura acrílica'
    },
    {
      src: `${cenografiaPath}33.jpg`,
      srcGrid: `${cenografiaPath}grid/33.jpg`,
      caption: 'Caixa multibanco falsa com parede cenografada para publicidade'
    },
    {
      src: `${cenografiaPath}34.jpg`,
      srcGrid: `${cenografiaPath}grid/34.jpg`,
      caption: 'Campa em esferovite'
    },
    {
      src: `${cenografiaPath}35.jpg`,
      srcGrid: `${cenografiaPath}grid/35.jpg`,
      caption: 'Capacete escafandro'
    },
    {
      src: `${cenografiaPath}36.jpg`,
      srcGrid: `${cenografiaPath}grid/36.jpg`,
      caption: 'Capacete escafandro em pvc para cenário'
    },
    {
      src: `${cenografiaPath}37.jpg`,
      srcGrid: `${cenografiaPath}grid/37.jpg`,
      caption: 'Caracóis falsos para efeito especial'
    },
    {
      src: `${cenografiaPath}38.jpg`,
      srcGrid: `${cenografiaPath}grid/38.jpg`,
      caption: 'Carro alegórico dia mundial da criança'
    },
    {
      src: `${cenografiaPath}39.jpg`,
      srcGrid: `${cenografiaPath}grid/39.jpg`,
      caption: 'Carro alegórico dia mundial da criança'
    },
    {
      src: `${cenografiaPath}40.jpg`,
      srcGrid: `${cenografiaPath}grid/40.jpg`,
      caption: 'Chave falsa para efeito especial'
    },
    {
      src: `${cenografiaPath}41.jpg`,
      srcGrid: `${cenografiaPath}grid/41.jpg`,
      caption: 'Colunas e arcos em esferovite a imitar pedra para cenário'
    },
    {
      src: `${cenografiaPath}42.jpg`,
      srcGrid: `${cenografiaPath}grid/42.jpg`,
      caption: 'Colunas em esferovite para publicidade'
    },
    {
      src: `${cenografiaPath}43.jpg`,
      srcGrid: `${cenografiaPath}grid/43.jpg`,
      caption: 'Construção de carrocaria para carrinho lunar'
    },
    {
      src: `${cenografiaPath}44.jpg`,
      srcGrid: `${cenografiaPath}grid/44.jpg`,
      caption: 'Adereços tipo sofás a imitar esculturas na areia para publicidade'
    },
    {
      src: `${cenografiaPath}45.jpg`,
      srcGrid: `${cenografiaPath}grid/45.jpg`,
      caption: 'Cabeça de lobo para publicidade'
    },
    {
      src: `${cenografiaPath}46.jpg`,
      srcGrid: `${cenografiaPath}grid/46.jpg`,
      caption: 'Cabeça de lobo para publicidade'
    },
    {
      src: `${cenografiaPath}47.jpg`,
      srcGrid: `${cenografiaPath}grid/47.jpg`,
      caption: 'Decoração com massas de barrar pintura e patine'
    },
    {
      src: `${cenografiaPath}48.jpg`,
      srcGrid: `${cenografiaPath}grid/48.jpg`,
      caption: 'Decoração de estabelecimento com parede tijolo de burro em esferovite e massa com patine '
    },
    {
      src: `${cenografiaPath}49.jpg`,
      srcGrid: `${cenografiaPath}grid/49.jpg`,
      caption: 'Decoração em esferovite para parede'
    },
    {
      src: `${cenografiaPath}50.jpg`,
      srcGrid: `${cenografiaPath}grid/50.jpg`,
      caption: 'Decoração estilo egípcio em baixo relevo'
    },
    {
      src: `${cenografiaPath}51.jpg`,
      srcGrid: `${cenografiaPath}grid/51.jpg`,
      caption: 'Decoração estilo egípcio em baixo relevo'
    },
    {
      src: `${cenografiaPath}52.jpg`,
      srcGrid: `${cenografiaPath}grid/52.jpg`,
      caption: 'Decoração estilo egípcio em escultura'
    },
    {
      src: `${cenografiaPath}53.jpg`,
      srcGrid: `${cenografiaPath}grid/53.jpg`,
      caption: 'Decoração estilo egípcio em baixo relevo'
    },
    {
      src: `${cenografiaPath}54.jpg`,
      srcGrid: `${cenografiaPath}grid/54.jpg`,
      caption: 'Dummie para efeito especial'
    },
    {
      src: `${cenografiaPath}55.jpg`,
      srcGrid: `${cenografiaPath}grid/55.jpg`,
      caption: 'Dummie para efeito especial'
    },
    {
      src: `${cenografiaPath}56.jpg`,
      srcGrid: `${cenografiaPath}grid/56.jpg`,
      caption: 'Gelado falso para efeito especial'
    },
    {
      src: `${cenografiaPath}57.jpg`,
      srcGrid: `${cenografiaPath}grid/57.jpg`,
      caption: 'Iglo em esferovite'
    },
    {
      src: `${cenografiaPath}58.jpg`,
      srcGrid: `${cenografiaPath}grid/58.jpg`,
      caption: 'Imitação de ferro lareira para efeito especial'
    },
    {
      src: `${cenografiaPath}59.jpg`,
      srcGrid: `${cenografiaPath}grid/59.jpg`,
      caption: 'Imitação de fonte em esferovite muito patinada'
    },
    {
      src: `${cenografiaPath}60.jpg`,
      srcGrid: `${cenografiaPath}grid/60.jpg`,
      caption: 'Imitação de gelo numa arca para efeitos especiais em publicidade'
    },
    {
      src: `${cenografiaPath}61.jpg`,
      srcGrid: `${cenografiaPath}grid/61.jpg`,
      caption: 'Imitação de pedra em esferovite para cenário'
    },
    {
      src: `${cenografiaPath}62.jpg`,
      srcGrid: `${cenografiaPath}grid/62.jpg`,
      caption: 'Imitação de pedra para cenário'
    },
    {
      src: `${cenografiaPath}63.jpg`,
      srcGrid: `${cenografiaPath}grid/63.jpg`,
      caption: 'Imitação de pedra para cenário'
    },
    {
      src: `${cenografiaPath}64.jpg`,
      srcGrid: `${cenografiaPath}grid/64.jpg`,
      caption: 'Imitação de pedra para cenário'
    },
    {
      src: `${cenografiaPath}65.jpg`,
      srcGrid: `${cenografiaPath}grid/65.jpg`,
      caption: 'Imitação de pedra para cenário'
    },
    {
      src: `${cenografiaPath}66.jpg`,
      srcGrid: `${cenografiaPath}grid/66.jpg`,
      caption: 'Imitação de pedra para publicidade'
    },
    {
      src: `${cenografiaPath}67.jpg`,
      srcGrid: `${cenografiaPath}grid/67.jpg`,
      caption: 'Imitação de tijolo inglês para cenário'
    },
    {
      src: `${cenografiaPath}68.jpg`,
      srcGrid: `${cenografiaPath}grid/68.jpg`,
      caption: 'Máscara em resina acrílica para publicidade'
    },
    {
      src: `${cenografiaPath}69.jpg`,
      srcGrid: `${cenografiaPath}grid/69.jpg`,
      caption: 'Mockup para publicidade'
    },
    {
      src: `${cenografiaPath}70.jpg`,
      srcGrid: `${cenografiaPath}grid/70.jpg`,
      caption: 'Muro de pedra em esferovite para publicidade'
    },
    {
      src: `${cenografiaPath}71.jpg`,
      srcGrid: `${cenografiaPath}grid/71.jpg`,
      caption: 'Parece cravos em tecido para museu'
    },
    {
      src: `${cenografiaPath}72.jpg`,
      srcGrid: `${cenografiaPath}grid/72.jpg`,
      caption: 'Parece em fibra para museu'
    },
    {
      src: `${cenografiaPath}73.jpg`,
      srcGrid: `${cenografiaPath}grid/73.jpg`,
      caption: 'Parece em tijolo burro patinado para publicidade'
    },
    {
      src: `${cenografiaPath}74.jpg`,
      srcGrid: `${cenografiaPath}grid/74.jpg`,
      caption: 'Parece a imitar pedra para cenário'
    },
    {
      src: `${cenografiaPath}75.jpg`,
      srcGrid: `${cenografiaPath}grid/75.jpg`,
      caption: 'Construção de disco voador FX para empresa de construção de cenários'
    },
    {
      src: `${cenografiaPath}76.jpg`,
      srcGrid: `${cenografiaPath}grid/76.jpg`,
      caption: 'Peça decorativa dia de los muertos para publicidade'
    },
    {
      src: `${cenografiaPath}77.jpg`,
      srcGrid: `${cenografiaPath}grid/77.jpg`,
      caption: 'Peça decorativa dia de los muertos para publicidade'
    },
    {
      src: `${cenografiaPath}78.jpg`,
      srcGrid: `${cenografiaPath}grid/78.jpg`,
      caption: 'Pedra para campa em esferovite para publicidade'
    },
    {
      src: `${cenografiaPath}79.jpg`,
      srcGrid: `${cenografiaPath}grid/79.jpg`,
      caption: 'Produção de cenário em baixo relevo para publicidade'
    },
    {
      src: `${cenografiaPath}80.jpg`,
      srcGrid: `${cenografiaPath}grid/80.jpg`,
      caption: 'Produção de parede em esferovite para empresa de construção de cenários'
    },
    {
      src: `${cenografiaPath}81.jpg`,
      srcGrid: `${cenografiaPath}grid/81.jpg`,
      caption: 'Produção de parede tipo fachada em pedra para cenário'
    },
    {
      src: `${cenografiaPath}82.jpg`,
      srcGrid: `${cenografiaPath}grid/82.jpg`,
      caption: 'Produção de paredes em pedra rústica em esferovite para filme'
    },
    {
      src: `${cenografiaPath}83.jpg`,
      srcGrid: `${cenografiaPath}grid/83.jpg`,
      caption: 'Produção de paredes tipo pedra para cenário'
    },
    {
      src: `${cenografiaPath}84.jpg`,
      srcGrid: `${cenografiaPath}grid/84.jpg`,
      caption: 'Réplica túmulo Rei D. Diniz em esferovite exposição temática'
    },
    {
      src: `${cenografiaPath}85.jpg`,
      srcGrid: `${cenografiaPath}grid/85.jpg`,
      caption: 'Talhe de adereços em madeira para publicidade'
    },
    {
      src: `${cenografiaPath}86.jpg`,
      srcGrid: `${cenografiaPath}grid/86.jpg`,
      caption: 'Talhe de rocha para publicidade'
    },
    {
      src: `${cenografiaPath}87.jpg`,
      srcGrid: `${cenografiaPath}grid/87.jpg`,
      caption: 'Talhe de rocha para publicidade'
    },
    {
      src: `${cenografiaPath}88.jpg`,
      srcGrid: `${cenografiaPath}grid/88.jpg`,
      caption: 'Talhe e pintura de cabeça de gato para programa'
    },
    {
      src: `${cenografiaPath}89.jpg`,
      srcGrid: `${cenografiaPath}grid/89.jpg`,
      caption: 'Talhe e pintura escarpas para exposição temática'
    },
    {
      src: `${cenografiaPath}90.jpg`,
      srcGrid: `${cenografiaPath}grid/90.jpg`,
      caption: 'Talhe e pintura escarpas para exposição temática'
    },
    {
      src: `${cenografiaPath}91.jpg`,
      srcGrid: `${cenografiaPath}grid/91.jpg`,
      caption: 'Reprodução de espingarda G3 em poliuretano compacto para filme'
    },
    {
      src: `${cenografiaPath}92.jpg`,
      srcGrid: `${cenografiaPath}grid/92.jpg`,
      caption: 'Roda de bicicleta com 4,2 metros para museu'
    },
    {
      src: `${cenografiaPath}93.jpg`,
      srcGrid: `${cenografiaPath}grid/93.jpg`,
      caption: 'Produção de faca falsa para efeitos especiais'
    },
    {
      src: `${cenografiaPath}94.jpg`,
      srcGrid: `${cenografiaPath}grid/94.jpg`,
      caption: 'Produção de pistola em borracha para efeitos especiais'
    },
    {
      src: `${cenografiaPath}95.jpg`,
      srcGrid: `${cenografiaPath}grid/95.jpg`,
      caption: 'Reprodução de espingardas G3 para filme'
    }

  ],
  corte: [
    {
      src: `${cortePath}1.jpg`,
      srcGrid: `${cortePath}/grid/1.jpg`,
      caption: 'Corte 2D e 3D cnc em esferovite'
    },
    {
      src: `${cortePath}2.jpg`,
      srcGrid: `${cortePath}/grid/2.jpg`,
      caption: 'Corte 2D e 3D cnc por fresa'
    },
    {
      src: `${cortePath}3.jpg`,
      srcGrid: `${cortePath}/grid/3.jpg`,
      caption: 'Corte e gravação de acrílico a laser '
    },
    {
      src: `${cortePath}4.jpg`,
      srcGrid: `${cortePath}/grid/4.jpg`,
      caption: 'Corte CNC esferovite 2D e 3D'
    }, 
    {
      src: `${cortePath}5.jpg`,
      srcGrid: `${cortePath}/grid/5.jpg`,
      caption: 'Peça 3D em CNC por fresa '
    },
    {
      src: `${cortePath}6.jpg`,
      srcGrid: `${cortePath}/grid/6.jpg`,
      caption: 'Corte e gravação a laser de troféus'
    },
    {
      src: `${cortePath}7.jpg`,
      srcGrid: `${cortePath}/grid/7.jpg`,
      caption: 'Corte letras em acrílico e madeira a laser para publicidade'
    },
    {
      src: `${cortePath}8.jpg`,
      srcGrid: `${cortePath}/grid/8.jpg`,
      caption: 'Corte CNC letras'
    },
    {
      src: `${cortePath}9.jpg`,
      srcGrid: `${cortePath}/grid/9.jpg`,
      caption: 'Corte CNC letras'
    },
    {
      src: `${cortePath}10.jpg`,
      srcGrid: `${cortePath}/grid/10.jpg`,
      caption: 'Corte e quinagem de acrílicos'
    },
    {
      src: `${cortePath}11.jpg`,
      srcGrid: `${cortePath}/grid/11.jpg`,
      caption: 'Corte laser'
    },
    {
      src: `${cortePath}12.jpg`,
      srcGrid: `${cortePath}/grid/12.jpg`,
      caption: 'Corte laser'
    },
    {
      src: `${cortePath}13.jpg`,
      srcGrid: `${cortePath}/grid/13.jpg`,
      caption: 'Peça 3D em cnc por fresa'
    }
  ],
  
  ultimos:[
    {
      src: `${ultimosTrabalhosPath}1.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/1.jpg`,
      caption: 'Reprodução de espingarda G3 em poliuretano compacto para filme'
    },
    {
      src: `${ultimosTrabalhosPath}2.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/2.jpg`,
      caption: 'Roda de bicicleta com 4,2 metros para museu'
    },
    {
      src: `${ultimosTrabalhosPath}3.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/3.jpg`,
      caption: 'Produção de faca falsa para efeitos especiais'
    },
    {
      src: `${ultimosTrabalhosPath}4.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/4.jpg`,
      caption: 'Produção de pistola em borracha para efeitos especiais'
    },
    {
      src: `${ultimosTrabalhosPath}5.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/5.jpg`,
      caption: 'Reprodução de espingardas G3 para filme'
    },
    {
      src: `${ultimosTrabalhosPath}6.jpg`,
      srcGrid: `${ultimosTrabalhosPath}grid/6.jpg`,
      caption: 'Molde de pistola'
    }
    
  ],
  barro: [
    {
      src: `${barroPath}1.jpg`,
      srcGrid: `${barroPath}grid/1.jpg`,
      caption: 'Busto em barro'
    },
    {
      src: `${barroPath}2.jpg`,
      srcGrid: `${barroPath}grid/2.jpg`,
      caption: 'Busto em barro'
    },
    {
      src: `${barroPath}3.jpg`,
      srcGrid: `${barroPath}grid/3.jpg`,
      caption: 'Escultura em barro S. Rafael'
    },
    {
      src: `${barroPath}4.jpg`,
      srcGrid: `${barroPath}grid/4.jpg`,
      caption: 'Escultura de mãos em cerâmica'
    },
    {
      src: `${barroPath}5.jpg`,
      srcGrid: `${barroPath}grid/5.jpg`,
      caption: 'Estudo modelação em barro para samurai'
    },
    {
      src: `${barroPath}6.jpg`,
      srcGrid: `${barroPath}grid/6.jpg`,
      caption: 'Escultura de barro'
    },
    {
      src: `${barroPath}7.jpg`,
      srcGrid: `${barroPath}grid/7.jpg`,
      caption: 'Escultura de barro'
    },
    {
      src: `${barroPath}8.jpg`,
      srcGrid: `${barroPath}grid/8.jpg`,
      caption: 'Escultura de barro'
    },
    {
      src: `${barroPath}9.jpg`,
      srcGrid: `${barroPath}grid/9.jpg`,
      caption: 'Escultura de barro'
    },
    {
      src: `${barroPath}10.jpg`,
      srcGrid: `${barroPath}grid/10.jpg`,
      caption: 'Escultura de barro'
    },
    {
      src: `${barroPath}11.jpg`,
      srcGrid: `${barroPath}grid/11.jpg`,
      caption: 'Estudo em barro auto retrato'
    },
    {
      src: `${barroPath}12.jpg`,
      srcGrid: `${barroPath}grid/12.jpg`,
      caption: 'Estudo de escultura em barro através de molde de gesso'
    },
    {
      src: `${barroPath}13.jpg`,
      srcGrid: `${barroPath}grid/13.jpg`,
      caption: 'Estudo de tronco em barro'
    },
    {
      src: `${barroPath}14.jpg`,
      srcGrid: `${barroPath}grid/14.jpg`,
      caption: 'Modelação de busto para publicidade'
    },
    {
      src: `${barroPath}15.jpg`,
      srcGrid: `${barroPath}grid/15.jpg`,
      caption: 'Pormenor de modelação para a composição escultórica na Igreja dos Pastorinhos'
    },
    {
      src: `${barroPath}16.jpg`,
      srcGrid: `${barroPath}grid/16.jpg`,
      caption: 'Retrato em barro'
    }
  ],
  esferovite: [
    {
      src: `${esferovitePath}1.jpg`,
      srcGrid: `${esferovitePath}grid/1.jpg`,
      caption: 'Cabeça de T-Rex para programa'
    },
    {
      src: `${esferovitePath}2.jpg`,
      srcGrid: `${esferovitePath}grid/2.jpg`,
      caption: 'Caveira para exposição temática'
    },
    {
      src: `${esferovitePath}3.jpg`,
      srcGrid: `${esferovitePath}grid/3.jpg`,
      caption: 'Decoração painel publicitário carnaval'
    },
    {
      src: `${esferovitePath}4.jpg`,
      srcGrid: `${esferovitePath}grid/4.jpg`,
      caption: 'Escultura para decoração egípcia'
    },
    {
      src: `${esferovitePath}5.jpg`,
      srcGrid: `${esferovitePath}grid/5.jpg`,
      caption: 'Escultura baixo relevo para publicidade'
    },
    {
      src: `${esferovitePath}6.jpg`,
      srcGrid: `${esferovitePath}grid/6.jpg`,
      caption: 'Escultura cabeça de gato e pintura para programe'
    },
    {
      src: `${esferovitePath}7.jpg`,
      srcGrid: `${esferovitePath}grid/7.jpg`,
      caption: 'Escultura cabeça de gato e pintura para programe'
    },
    {
      src: `${esferovitePath}8.jpg`,
      srcGrid: `${esferovitePath}grid/8.jpg`,
      caption: 'Escultura de cabeça de vaca em esferovite para publicidade'
    },
    {
      src: `${esferovitePath}9.jpg`,
      srcGrid: `${esferovitePath}grid/9.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esferovitePath}10.jpg`,
      srcGrid: `${esferovitePath}grid/10.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esferovitePath}11.jpg`,
      srcGrid: `${esferovitePath}grid/11.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esferovitePath}12.jpg`,
      srcGrid: `${esferovitePath}grid/12.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esferovitePath}13.jpg`,
      srcGrid: `${esferovitePath}grid/13.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${esferovitePath}14.jpg`,
      srcGrid: `${esferovitePath}grid/14.jpg`,
      caption: 'Escultura de fonte com gárgula para série'
    },
    {
      src: `${esferovitePath}15.jpg`,
      srcGrid: `${esferovitePath}grid/15.jpg`,
      caption: 'Escultura de nariz para publicidade'
    },
    {
      src: `${esferovitePath}16.jpg`,
      srcGrid: `${esferovitePath}grid/16.jpg`,
      caption: 'Escultura em baixo relevo para publicidade'
    },
    {
      src: `${esferovitePath}17.jpg`,
      srcGrid: `${esferovitePath}grid/17.jpg`,
      caption: 'Escultura de jogador para publicidade'
    },
    {
      src: `${esferovitePath}18.jpg`,
      srcGrid: `${esferovitePath}grid/18.jpg`,
      caption: 'Escultura em esferovite e cimento para série'
    },
    {
      src: `${esferovitePath}19.jpg`,
      srcGrid: `${esferovitePath}grid/19.jpg`,
      caption: 'Escultura em esferovite e cimento para série'
    },
    {
      src: `${esferovitePath}20.jpg`,
      srcGrid: `${esferovitePath}grid/20.jpg`,
      caption: 'Escultura em esferovite e cimento para série'
    },
    {
      src: `${esferovitePath}21.jpg`,
      srcGrid: `${esferovitePath}grid/21.jpg`,
      caption: 'Escultura em esferovite e massa com patine para novela'
    },
    {
      src: `${esferovitePath}22.jpg`,
      srcGrid: `${esferovitePath}grid/22.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${esferovitePath}23.jpg`,
      srcGrid: `${esferovitePath}grid/23.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${esferovitePath}24.jpg`,
      srcGrid: `${esferovitePath}grid/24.jpg`,
      caption: 'Escultura em esferovite e massa para novela'
    },
    {
      src: `${esferovitePath}25.jpg`,
      srcGrid: `${esferovitePath}grid/25.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${esferovitePath}26.jpg`,
      srcGrid: `${esferovitePath}grid/26.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}27.jpg`,
      srcGrid: `${esferovitePath}grid/27.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}28.jpg`,
      srcGrid: `${esferovitePath}grid/28.jpg`,
      caption: 'Escultura em esferovite para presépio'
    },
    {
      src: `${esferovitePath}29.jpg`,
      srcGrid: `${esferovitePath}grid/29.jpg`,
      caption: 'Escultura em esferovite para série'
    },
    {
      src: `${esferovitePath}30.jpg`,
      srcGrid: `${esferovitePath}grid/30.jpg`,
      caption: 'Escultura em esferovite para série'
    },
    {
      src: `${esferovitePath}31.jpg`,
      srcGrid: `${esferovitePath}grid/31.jpg`,
      caption: 'Escultura em esferovite para série'
    },
    {
      src: `${esferovitePath}32.jpg`,
      srcGrid: `${esferovitePath}grid/32.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}33.jpg`,
      srcGrid: `${esferovitePath}grid/33.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}34.jpg`,
      srcGrid: `${esferovitePath}grid/34.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}35.jpg`,
      srcGrid: `${esferovitePath}grid/35.jpg`,
      caption: 'Escultura em esferovite para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}36.jpg`,
      srcGrid: `${esferovitePath}grid/36.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}37.jpg`,
      srcGrid: `${esferovitePath}grid/37.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}38.jpg`,
      srcGrid: `${esferovitePath}grid/38.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}39.jpg`,
      srcGrid: `${esferovitePath}grid/39.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}40.jpg`,
      srcGrid: `${esferovitePath}grid/40.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}41.jpg`,
      srcGrid: `${esferovitePath}grid/41.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}42.jpg`,
      srcGrid: `${esferovitePath}grid/42.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}43.jpg`,
      srcGrid: `${esferovitePath}grid/43.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}44.jpg`,
      srcGrid: `${esferovitePath}grid/44.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    }, 
     {
      src: `${esferovitePath}45.jpg`,
      srcGrid: `${esferovitePath}grid/45.jpg`,
      caption: 'Escultura em esferovite e pintura para marchas de Lisboa'
    },
    {
      src: `${esferovitePath}46.jpg`,
      srcGrid: `${esferovitePath}grid/46.jpg`,
      caption: 'Escultura para decoração Egípcia'
    },
    {
      src: `${esferovitePath}47.jpg`,
      srcGrid: `${esferovitePath}grid/47.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}48.jpg`,
      srcGrid: `${esferovitePath}grid/48.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}49.jpg`,
      srcGrid: `${esferovitePath}grid/49.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}50.jpg`,
      srcGrid: `${esferovitePath}grid/50.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    }, 
    {
      src: `${esferovitePath}51.jpg`,
      srcGrid: `${esferovitePath}grid/51.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}52.jpg`,
      srcGrid: `${esferovitePath}grid/52.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}53.jpg`,
      srcGrid: `${esferovitePath}grid/53.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}54.jpg`,
      srcGrid: `${esferovitePath}grid/54.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}55.jpg`,
      srcGrid: `${esferovitePath}grid/55.jpg`,
      caption: 'Escultura em esferovite e PVC de brasão para filme'
    },
    {
      src: `${esferovitePath}56.jpg`,
      srcGrid: `${esferovitePath}grid/56.jpg`,
      caption: 'Escultura de fonte com gárgula para série'
    },
    {
      src: `${esferovitePath}57.jpg`,
      srcGrid: `${esferovitePath}grid/57.jpg`,
      caption: 'Réplica túmulo de D. Dinis em Esferovite'
    },
    {
      src: `${esferovitePath}58.jpg`,
      srcGrid: `${esferovitePath}grid/58.jpg`,
      caption: 'Talhe de moeda da primeira república para exposição temática'
    },
    {
      src: `${esferovitePath}59.jpg`,
      srcGrid: `${esferovitePath}grid/59.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}60.jpg`,
      srcGrid: `${esferovitePath}grid/60.jpg`,
      caption: 'Talhe de pedra em esferovite e massa para filme'
    },
    {
      src: `${esferovitePath}61.jpg`,
      srcGrid: `${esferovitePath}grid/61.jpg`,
      caption: 'Esculturas para exposição temática museu'
    },
    {
      src: `${esferovitePath}62.jpg`,
      srcGrid: `${esferovitePath}grid/62.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}63.jpg`,
      srcGrid: `${esferovitePath}grid/63.jpg`,
      caption: 'Produção de decoração de Natal em esferovite e madeira'
    },
    {
      src: `${esferovitePath}64.jpg`,
      srcGrid: `${esferovitePath}grid/64.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    },
    {
      src: `${esferovitePath}65.jpg`,
      srcGrid: `${esferovitePath}grid/65.jpg`,
      caption: 'Escultura para carros alegóricos de carnaval'
    }
    
  ],
  fibra: [
    {
      src: `${fibraPath}1.jpg`,
      srcGrid: `${fibraPath}grid/1.jpg`,
      caption: 'Andorinha Lgbt para exposição galerias Lafayette'
    },
    {
      src: `${fibraPath}2.jpg`,
      srcGrid: `${fibraPath}grid/2.jpg`,
      caption: 'Andorinha Lgbt para exposição galerias Lafayette'
    },
    {
      src: `${fibraPath}3.jpg`,
      srcGrid: `${fibraPath}grid/3.jpg`,
      caption: 'Burro em fibra de vidro'
    },
    {
      src: `${fibraPath}4.jpg`,
      srcGrid: `${fibraPath}grid/4.jpg`,
      caption: 'Escultura de cavalo carrocel para decoração de novela'
    },
    {
      src: `${fibraPath}5.jpg`,
      srcGrid: `${fibraPath}grid/5.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${fibraPath}6.jpg`,
      srcGrid: `${fibraPath}grid/6.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${fibraPath}7.jpg`,
      srcGrid: `${fibraPath}grid/7.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    {
      src: `${fibraPath}8.jpg`,
      srcGrid: `${fibraPath}grid/8.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    },
    /* {
      src: `${fibraPath}9.jpg`,
      srcGrid: `${fibraPath}grid/9.jpg`,
      caption: 'Escultura de Cristo em poliuretano de alta densidade'
    }, */
    {
      src: `${fibraPath}10.jpg`,
      srcGrid: `${fibraPath}grid/10.jpg`,
      caption: 'Escultura em esferovite e massa Rei D. Dinis'
    },
    /* {
      src: `${fibraPath}11.jpg`,
      srcGrid: `${fibraPath}grid/11.jpg`,
      caption: 'Escultura em esferovite e pintura para marchas de Lisboa'
    }, */
    {
      src: `${fibraPath}12.jpg`,
      srcGrid: `${fibraPath}grid/12.jpg`,
      caption: 'Escultura em esferovite e PVC de brasão para filme'
    },
    {
      src: `${fibraPath}13.jpg`,
      srcGrid: `${fibraPath}grid/13.jpg`,
      caption: 'Escultura em esferovite e resina no palácio de Oeiras'
    },
    {
      src: `${fibraPath}14.jpg`,
      srcGrid: `${fibraPath}grid/14.jpg`,
      caption: 'Escultura em fibra e resina acrílica exposição temática em Timor'
    },
    {
      src: `${fibraPath}15.jpg`,
      srcGrid: `${fibraPath}grid/15.jpg`,
      caption: 'Escultura em fibra e resina acrílica exposição temática em Timor'
    },
    {
      src: `${fibraPath}16.jpg`,
      srcGrid: `${fibraPath}grid/16.jpg`,
      caption: 'Escultura em fibra e resina acrílica exposição temática em Timor'
    },
    {
      src: `${fibraPath}17.jpg`,
      srcGrid: `${fibraPath}grid/17.jpg`,
      caption: 'Escultura em fibra S. Rafael'
    },
    {
      src: `${fibraPath}18.jpg`,
      srcGrid: `${fibraPath}grid/18.jpg`,
      caption: 'Escultura de Cristo para filme'
    } ,
    {
      src: `${fibraPath}19.jpg`,
      srcGrid: `${fibraPath}grid/19.jpg`,
      caption: 'Escultura de Cristo para filme'
    },
    {
      src: `${fibraPath}20.jpg`,
      srcGrid: `${fibraPath}grid/20.jpg`,
      caption: 'Presépio Natal em fibra resina e tecido serapilheira'
    },
    {
      src: `${fibraPath}21.jpg`,
      srcGrid: `${fibraPath}grid/21.jpg`,
      caption: 'Presépio em fibra resina e tecido serrapilheira'
    },
    {
      src: `${fibraPath}22.jpg`,
      srcGrid: `${fibraPath}grid/22.jpg`,
      caption: 'Escultura em esferovite e resina no palácio de Oeiras, pormenor'
    },
    {
      src: `${fibraPath}23.jpg`,
      srcGrid: `${fibraPath}grid/23.jpg`,
      caption: 'Escultura peça presépio'
    },
    {
      src: `${fibraPath}24.jpg`,
      srcGrid: `${fibraPath}grid/24.jpg`,
      caption: 'Esculturas em fibra epóxi em ISEG'
    },
    {
      src: `${fibraPath}25.jpg`,
      srcGrid: `${fibraPath}grid/25.jpg`,
      caption: 'Estudo de escultura em poliuretano e resina'
    }
    ,
    {
      src: `${fibraPath}26.jpg`,
      srcGrid: `${fibraPath}grid/26.jpg`,
      caption: 'Pormenor da Composição escultórica na Igreja dos Pastorinhos'
    }   
  ],
  gesso: [
    {
      src: `${gessoPath}1.jpg`,
      srcGrid: `${gessoPath}grid/1.jpg`,
      caption: 'Escultura de Cristo para filme'
    }, 
    {
      src: `${gessoPath}2.jpg`,
      srcGrid: `${gessoPath}grid/2.jpg`,
      caption: 'Escultura de nariz para publicidade'
    },
    {
      src: `${gessoPath}3.jpg`,
      srcGrid: `${gessoPath}grid/3.jpg`,
      caption: 'Escultura em gesso'
    },
    {
      src: `${gessoPath}4.jpg`,
      srcGrid: `${gessoPath}grid/4.jpg`,
      caption: 'Escultura em esferovite e massa com patine para novela'
    },
    {
      src: `${gessoPath}5.jpg`,
      srcGrid: `${gessoPath}grid/5.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${gessoPath}6.jpg`,
      srcGrid: `${gessoPath}grid/6.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${gessoPath}7.jpg`,
      srcGrid: `${gessoPath}grid/7.jpg`,
      caption: 'Escultura em esferovite e massa para exposição temática'
    },
    {
      src: `${gessoPath}8.jpg`,
      srcGrid: `${gessoPath}grid/8.jpg`,
      caption: 'Escultura em esferovite e massa para novela'
    },
    {
      src: `${gessoPath}9.jpg`,
      srcGrid: `${gessoPath}grid/9.jpg`,
      caption: 'Escultura em esferovite e massa, Rei D. Dinis'
    },
    {
      src: `${gessoPath}10.jpg`,
      srcGrid: `${gessoPath}grid/10.jpg`,
      caption: 'Escultura em esferovite emassa para exposiçãoo temática'
    },
    {
      src: `${gessoPath}11.jpg`,
      srcGrid: `${gessoPath}grid/11.jpg`,
      caption: 'Escultura em esferovite, massa e patine para publicidade'
    } 
  ],
  madeira: [
    {
      src: `${madeiraPath}1.jpg`,
      srcGrid: `${madeiraPath}grid/1.jpg`,
      caption: 'Escultura em madeira de pinho'
    },
    {
      src: `${madeiraPath}2.jpg`,
      srcGrid: `${madeiraPath}grid/2.jpg`,
      caption: 'Escultura em madeira de pinho'
    },
    {
      src: `${madeiraPath}3.jpg`,
      srcGrid: `${madeiraPath}grid/3.jpg`,
      caption: 'Escultura em madeira de pinho'
    },
    {
      src: `${madeiraPath}4.jpg`,
      srcGrid: `${madeiraPath}grid/4.jpg`,
      caption: 'Escultura em madeira de pinho'
    },
    {
      src: `${madeiraPath}5.jpg`,
      srcGrid: `${madeiraPath}grid/5.jpg`,
      caption: 'Estudo de talhe em madeira'
    },
    {
      src: `${madeiraPath}6.jpg`,
      srcGrid: `${madeiraPath}grid/6.jpg`,
      caption: 'Estudo escultura em ripas madeira pinho'
    }  
  ],
  moldes: [
    {
      src: `${moldesPath}1.jpg`,
      srcGrid: `${moldesPath}grid/1.jpg`,
      caption: 'Molde de busto'
    },
    {
      src: `${moldesPath}2.jpg`,
      srcGrid: `${moldesPath}grid/2.jpg`,
      caption: 'Molde em silicone e gesso'
    },
    {
      src: `${moldesPath}3.jpg`,
      srcGrid: `${moldesPath}grid/3.jpg`,
      caption: 'Produção de molde em silicone para busto em fibra'
    },
    {
      src: `${moldesPath}4.jpg`,
      srcGrid: `${moldesPath}grid/4.jpg`,
      caption: 'Reprodução de mão e braço em gesso através de molde de alginato'
    },
    {
      src: `${moldesPath}5.jpg`,
      srcGrid: `${moldesPath}grid/5.jpg`,
      caption: 'Reprodução de mão e braço em gesso através de molde de alginato'
    },
    {
      src: `${moldesPath}6.jpg`,
      srcGrid: `${moldesPath}grid/6.jpg`,
      caption: 'Reprodução de mão e braço em gesso através de molde de alginato'
    },
    {
      src: `${moldesPath}7.jpg`,
      srcGrid: `${moldesPath}grid/7.jpg`,
      caption: 'Reprodução de mão e braço em gesso através de molde de alginato'
    },
    {
      src: `${moldesPath}8.jpg`,
      srcGrid: `${moldesPath}grid/8.jpg`,
      caption: 'Reprodução de mão e braço em gesso através de molde de alginato'
    },
    {
      src: `${moldesPath}9.jpg`,
      srcGrid: `${moldesPath}grid/9.jpg`,
      caption: 'Tiragem de peças em fibra'
    },
    {
      src: `${moldesPath}10.jpg`,
      srcGrid: `${moldesPath}grid/10.jpg`,
      caption: 'Tiragem de peças em fibra'
    },
    {
      src: `${moldesPath}11.jpg`,
      srcGrid: `${moldesPath}grid/11.jpg`,
      caption: 'Molde espingarda'
    },
    {
      src: `${moldesPath}12.jpg`,
      srcGrid: `${moldesPath}grid/12.jpg`,
      caption: 'Molde espingarda'
    },
    {
      src: `${moldesPath}13.jpg`,
      srcGrid: `${moldesPath}grid/13.jpg`,
      caption: 'Molde pistola'
    },
    {
      src: `${moldesPath}14.jpg`,
      srcGrid: `${moldesPath}grid/14.jpg`,
      caption: 'Molde pistola'
    }
  ]


}
